import { Flex, Select, Spacer } from '@chakra-ui/react'
import React, { useCallback } from 'react'
import ReactPaginate from 'react-paginate'

import './TablePagination.css'
const TablePagination = ({ table, dataCount }) => {
  const pageIndex = table.getState().pagination.pageIndex
  const pageSize = table.getState().pagination.pageSize
  const pageCount = table.getPageCount()

  const handleChangePage = useCallback(
    ({ selected }) => {
      table.setPageIndex(selected)
    },
    [table]
  )
  return (
    <Flex>
      <ReactPaginate
        breakLabel="..."
        forcePage={pageIndex}
        nextLabel=">"
        onPageChange={handleChangePage}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="<"
        renderOnZeroPageCount={null}
        pageClassName="pagination__item"
        pageLinkClassName="pagination__link"
        previousClassName="pagination__item"
        previousLinkClassName="pagination__link"
        nextClassName="pagination__item"
        nextLinkClassName="pagination__link"
        breakClassName="pagination__item"
        breakLinkClassName="pagination__link"
        containerClassName="pagination__container"
        activeClassName="active"
      />
      <Spacer />
      <Select
        value={pageSize}
        onChange={(e) => {
          table.setPageSize(Number(e.target.value))
        }}
        maxW="200px"
      >
        {[5, 10, 20, 30].map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </Select>
    </Flex>
  )
}

export default TablePagination
